export interface ICoveragePayloadType {
    coverageAlias: string;
    selected: boolean;
}

export enum BRAND {
    TOPDANMARK = 'TD'
}
export enum PRODUCTKEY {
    INDBO = 'CONTENT'
}

export enum PRODUCTNAME {
    INDBO = 'Indbo'
}

export enum PREMIUMRATE {
    MONTHLY = 12,
    YEARLY = 1
}

export enum PACKAGE_TYPE {
    PREMIUM = 'PREMIUM',
    STANDARD = 'STANDARD',
    BASIS = 'BASIS'
}

export function packageType2ColumnNumber(p: PACKAGE_TYPE) {
    switch (p) {
        case PACKAGE_TYPE.PREMIUM:
            return 1;
        case PACKAGE_TYPE.STANDARD:
            return 2;
        case PACKAGE_TYPE.BASIS:
            return 3;
    }
}

export enum CLAIM_TYPE {
    CLOUDBURST = 'CLOUDBURST',
    BURGLARY = 'BURGLARY',
    OTHER = 'OTHER'
}

export enum TERMINATION_WHEN {
    QUICK = 'QUICK',
    CHOOSE = 'CHOOSE',
    DUEDATE = 'DUEDATE'
}

export const MIN_AGE = 18;
export const MAX_AGE = 99;

export interface ICreatePackage {
    brand: BRAND;
    productKey: PRODUCTKEY;
    kvhxKey: string; // for moving scenario, this is set to the new address
    alreadyCovered: boolean;
    householdSize: number;
    numberOfClaims: number;
    isMovingScenario?: boolean;
    cprNo?: string;
    claimType?: CLAIM_TYPE;
    claimAmount?: number;
    notCoveredReason?: string;
}

export interface IUpdatePackage {
    brand: BRAND;
    productKey: PRODUCTKEY;
    quoteIds: Array<number>;
    deductible: number;
    additionalCoverage?: ICoveragePayloadType;
    additionalCoverages?: [];
}

export interface ICoverageList {
    coverageId: number;
    coverageAlias: string;
    name: string;
    selected: boolean;
    deductableBasis: number;
    deductableAmount: number;
}

// Package screen
export interface IPackageDetailsListType {
    packageName: PACKAGE_TYPE;
    productDiscountPct?: number;
    quoteId: number;
    productId: number;
    coverages?: Array<ICoverageList>;
    monthlyPrice: number;
    yearlyPrice: number;
}

// Actually the response from MT but also used for the request.
export interface IPackageDetails {
    brand: BRAND;
    productKey: PRODUCTKEY;
    customerId?: string;
    hasProductDiscount?: boolean;
    packages: IPackageDetailsListType[];
    existingInsurances?: {
        discountPct: number;
        insurances: Array<string>;
    };
}

export enum EMAIL_IDENTIFIER {
    CONTENT_CALLME = 'CONTENT_CALLME',
    CONTENT_SALES_COMPLETE = 'CONTENT_SALES_COMPLETE',
    GENERAL_CALLME = 'GENERAL_CALLME'
}

export enum EMAIL_EVENT {
    EXISTING_CONTENT_DIFF_ADDRESS = 'EXISTING_CONTENT_DIFF_ADDRESS',
    NO_EXISTING_INSURANCE = 'NO_EXISTING_INSURANCE', // Claims page
    TOO_MANY_CLAIMS = 'TOO_MANY_CLAIMS', // Claims page
    TOO_HIGH_CLAIM_AMOUNT = 'TOO_HIGH_CLAIM_AMOUNT', // Claims page
    SALES_COMPLETE = 'SALES_COMPLETE',
    GENERAL_ERROR = 'GENERAL_ERROR',
    INSURANCE_ACTIVATED = 'INSURANCE_ACTIVATED',
    EXISTING_INSURANCE_LATE = 'EXISTING_INSURANCE_LATE',
    MOVING_SCENARIO = 'MOVING_SCENARIO',
    NOT_MOVING_SCENARIO = 'NOT_MOVING_SCENARIO',
    SUM_NOT_BIG_ENOUGH = 'SUM_NOT_BIG_ENOUGH',
    MOVING_SCENARIO_DIFF_HOUSEHOLD = 'MOVING_SCENARIO_DIFF_HOUSEHOLD'
}

export interface IEmailTemplate {
    identifier: EMAIL_IDENTIFIER;
    event: EMAIL_EVENT;
    insuredAddress: string;
    phoneNumber: string;
    householdSize: number;
    alreadyCovered: boolean;
    productName?: string;
    notAlreadyCoveredCause?: string;
    fullName?: string;
    numberOfClaims?: number;
    claimType?: string;
    claimDescription?: string;
    claimAmountDescription?: string;
    customerId?: string;
    newAddress?: string;
}

export interface IGeneralCallMeEmailTemplate {
    identifier: EMAIL_IDENTIFIER;
    event: EMAIL_EVENT;
    productName: PRODUCTNAME;
    phoneNumber: string;
    fullName?: string;
}

export interface ISalesCompleteEmail {
    identifier: EMAIL_IDENTIFIER;
    event: EMAIL_EVENT;
    quoteId: number;
    cprNumber: string;
    fullName: string;
    residentialAddress: string;
    phoneNumber: string;
    emailAddress: string;
    effectiveDate: string;
    currentInsuranceCompany?: string;
    bankRegistrationNumber?: string;
    bankAccountNumber?: string;
    premiumRateDescription: string;
    insuredAddress: string;
    oldestInHousehold: number;
    householdSize: number;
    mostExpensiveItemAmount: string;
    alreadyCovered: boolean;
    notAlreadyCoveredCause?: string;
    eboks: boolean;
    newAddress?: string;
}

export interface IBuyInsurance {
    productKey: PRODUCTKEY;
    brand: BRAND;
    quoteId: number;
    emailAddress: string;
    kvhxKey?: string;
    productId: number;
    premiumRate: PREMIUMRATE;
    bankRegistrationNumber?: string;
    bankAccountNumber?: string;
    accept?: boolean;
    effectiveDate?: string;
    packageName: string;
    eboks: boolean;
    householdSize: number;
    isMovingScenario?: boolean;
}

export interface IGetStakeholderInfo {
    firstName: string;
    lastName: string;
    cprNo: string; //"1910872369"
    customerId: string; //"504401B"
    emailAddress: string;
    emailPriority: number;
    mobilePhone: string;
    streetAddress: string; //"Vejlebrovej 64, 3 Th"
    zipCity: string; //"2635 Ishøj",
    village: string;
    country: string; //"Danmark"
}
export interface IGetCustomerContentStatus {
    canProceed: boolean;
    message: CustomerContentStatusMessage;
    hasInsurance: string;
    movingScenario: boolean;
}

export enum CustomerContentStatusMessage {
    TRIES_TO_CALCULATE_ON_ADDRESS_WITH_CONTENT_INSURANCE = "Customer's GTI address matches the provided address",
    IS_MOVING_SCENARIO = "Customer's GTI address is different from the provided address",
    IS_INSURING_OWN_ADDRESS = "Customer's GTI address matches the provided address"
}

export interface IGetCustomerHouseholdSize {
    householdSize: number;
}

export interface IGetPaymentAgreement {
    quoteId: number;
    productId: number;
}

export type TRequestStatus = 'none' | 'in-progress' | 'logged-on-success' | 'logged-on-error' | 'not-logged-on';

export interface IRequestInfo<T, K> {
    progress: TRequestStatus;
    value: T;
    cpr?: K;
}

export interface IPutStakeholderInfo {
    email: string;
    cellphone: string;
}
